var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPajaro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "210mm",
    height: "297mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 21000 29700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10284.61 7773.78 658.67 321.21s-548.07 816.16-545.92 1319.01c2.15 502.85 8.56 652.03 8.56 652.03s-187.37 152.46-237.61 38.18c-50.25-114.28-67.81-156.43-67.81-156.43s-17.17 289.06-142.72 235.86c-125.55-53.21-153.77 82.85-285.29 34.87-215.88-78.73-184.13-156.6-433.31-56.19-196.4 79.16-445.97 169.27-543.35 182.26-16.06 2.15-38.36 5.95-64.36 10.78l-4.24-.96s116.25-165.98 93.66-436.42c-22.6-270.44-306.31-694.73-489.65-1357.93-183.35-663.21 679.38-733.31 1149.99-717.27 302.24 10.28 1007.18-18.38 903.38-69z"
  })), /*#__PURE__*/React.createElement("style", null, ".fil3{fill:#2a2d36}"))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_105553227564736"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15149.85 10720.6c-15.52-241.68-141.63-479.64-681.9-130.07-891.27 576.73-3808.16 2511.75-4220.54 3119.53-6233.38 9187.1 2165.76-833.13 4718.63-1101.01 619.39-64.99 1791.19-822.37 1791.19-1248.9 0-693.37-448.33-757.41-891.46-593.4-495.4 183.34-681.46 491.45-715.92-46.15z",
    style: {
      fill: "#630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9880.53 14254.22c-5332.69 7951.72 2055.32-755.62 4814.57-1587.37-765.32 169.63-3006.7 710.36-4814.57 1587.37z",
    style: {
      fill: "#3c1400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6962.6 14436.68c1.45 24.54-98.17 1078.83-96.35 1103.28 64.8 628.99 716.76-37.05 731.26-23.36 70.18 28.81 128.09 496.9 586.05 305.47 457.95-191.44 464.81-1163.76 1053.77-1213.93 588.96-50.17 350.68-1054.98 853.4-1283.22 502.73-228.24 823.39-224.02 938.73-375.08 115.34-151.05 105.82-1480.13 105.82-1480.13l-94.87-216.91-796.94-866.85-581.91 335.04s-135.64 44.03-338.25 112.46c3.19 7.3 6.27 14.62 9.13 22.07 76.59 199.11-269.16 452.01-563.08 624.8l-55.13 116.11c-388.3 94.17-1107.96 231.74-1378.13 481.51l-316.3 890.4c-2.89 8.07-81.25 790.58-57.2 1468.34z",
    style: {
      fill: "#4a4e5a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7117.11 14359.48c66.47 647.59 343.01 900.49 343.01 900.49l-1133.35 2550.45-96-199.67s331.57-2374.85 420.61-3283.81c89.05-908.95 45.86-1942.6 484.52-2573.64 438.67-631.04 1137.07-1322.04 1137.07-1322.04s549.37-540.17 674.16-315.55c124.79 224.61 158.06 657.18 158.06 657.18l-390.96 823.54s-378.41 91.75-620.38 234.23c-760.25 447.62-1059.65 1721.19-976.74 2528.82z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8598.44 10357.58s261.64 27.85 208.14 462.05c-53.5 434.21-706.89 939.47-274.46 1062.09 432.42 122.61 774.87-228.54 1139.34-498.29 364.47-269.75 616.14-551.96 946.32-387.14 330.18 164.82 517.5 473.42 517.5 473.42-65.37-659.4-774.4-945.51-734.52-1645.78l-446.6-223.78-253.85 512.15c-124.21-20.35-209.36-31.28-209.36-31.28l-892.51 276.56z",
    style: {
      fill: "#1e1e25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8365.84 7145.61s-328.92 606.54 334.75 573.32c663.67-33.23 1584.02 54.85 1584.02 54.85l658.67 321.21s-548.07 816.16-545.92 1319.01c2.15 502.85 8.56 652.03 8.56 652.03s-187.37 152.46-237.61 38.18c-50.25-114.28-67.81-156.43-67.81-156.43s-17.17 289.06-142.72 235.86c-125.55-53.21-151.99 77.67-285.29 34.87-133.3-42.79-229.64-317.57-229.64-317.57s-7.28 182.23-203.67 261.38c-196.4 79.16-445.97 169.27-543.35 182.26-97.39 13-422.86 86.68-422.86 86.68s175.68-349.82 64.18-550.4c-248.88-447.8-996.84-2362.54-255.12-2654.2 171.55-67.46 283.81-81.05 283.81-81.05z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10284.61 7773.78 658.67 321.21s-548.07 816.16-545.92 1319.01c2.15 502.85 8.56 652.03 8.56 652.03s-187.37 152.46-237.61 38.18c-50.25-114.28-67.81-156.43-67.81-156.43s-17.17 289.06-142.72 235.86c-125.55-53.21-153.77 82.85-285.29 34.87-215.88-78.73-184.13-156.6-433.31-56.19-196.4 79.16-445.97 169.27-543.35 182.26-16.06 2.15-38.36 5.95-64.36 10.78l-4.24-.96s116.25-165.98 93.66-436.42c-22.6-270.44-306.31-694.73-489.65-1357.93-183.35-663.21 679.38-733.31 1149.99-717.27 302.24 10.28 1007.18-18.38 903.38-69z",
    style: {
      fill: "#981619"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M10168.24 7960.51s-281.45 224.78-425.4 241.33c-143.95 16.56-235.42 134.21-8.88 462.94s276.48 475.59 197.97 830.3c-78.51 354.7-471.94 607.36-471.94 607.36l-224.81 190.96 1114.35 156.93 777.07-754.08s605.33-1341.99 553.93-1450.48c-51.41-108.48-809.82-500.08-809.82-500.08l-702.47 214.82z",
    style: {
      fill: "#671718"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10284.61 7773.78 658.67 321.21s-548.07 816.16-545.92 1319.01c2.15 502.85 8.56 652.03 8.56 652.03s-187.37 152.46-237.61 38.18c-50.25-114.28-67.81-156.43-67.81-156.43s-17.17 289.06-142.72 235.86c-125.55-53.21-153.77 82.85-285.29 34.87-215.88-78.73-184.13-156.6-433.31-56.19-196.4 79.16-445.97 169.27-543.35 182.26-16.06 2.15-38.36 5.95-64.36 10.78l-4.24-.96s116.25-165.98 93.66-436.42c-22.6-270.44-306.31-694.73-489.65-1357.93-183.35-663.21 679.38-733.31 1149.99-717.27 302.24 10.28 1007.18-18.38 903.38-69z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10284.61 7773.78s-124.74 194.47-237.71 352.26c-112.97 157.8-229.67 195.83-229.67 195.83l412.99 146.22s32.76-56.34 110.36-104.76 197.9-194.88 380.5-229.19c182.61-34.32 205.74-21.17 205.74-21.17l997.36-1089.71-1639.57 750.52z",
    style: {
      fill: "#655e62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9181.81 8077.11c214.07-43.69 387.59 33.63 387.59 172.68 0 139.11-173.52 287.25-387.59 330.93-214.03 43.68-387.55-33.63-387.55-172.69 0-139.05 173.52-287.24 387.55-330.92z",
    style: {
      fill: "#6c3f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9164.77 8138.95c80 0 144.82 64.82 144.82 144.77 0 79.99-64.82 144.81-144.82 144.81-79.95 0-144.77-64.82-144.77-144.81 0-79.95 64.82-144.77 144.77-144.77z",
    style: {
      fill: "#e99b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9164.77 8225.14c32.36 0 58.62 26.22 58.62 58.58 0 32.4-26.26 58.62-58.62 58.62s-58.57-26.22-58.57-58.62c0-32.36 26.21-58.58 58.57-58.58z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11055.14 12955.1c-1492.41 3127.86-3157.02 5280.89-4844.82 8128.39-247.89 418.22-521.96 797.49-741.02 1080.07v.02s-295.85 422.39-414.99 504.18c-75.16 51.61-64.13-106.5-51.9-239.51-70.59 50.32-138.5 94.3-186.87 115.91-98.52 44.03-117.68-134.08-118.57-269.75-32.71 17.04-62.65 28.79-88.55 33.47-140.03 25.41-141.74-133.47-123.9-254.43-95.46 62.5-176.24 115.71-219.95 145.11-152.93 102.88 226.09-615.4 292.86-740.53l-2.22-.94c809.8-1611.99 1785.67-4422.33 2850.59-6227.24 80.24 56.51 180.54 67.91 305.89 15.52 817.07-341.58 858.02-1216.23 1447-1266.4 588.98-50.17 350.68-950.12 853.41-1178.36 502.72-228.24 902.02 300.29 1017.36 149.23 1.43-1.85 2.81-4.04 4.19-6.26l21.49 11.52z",
    style: {
      fill: "#141314"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4555.21 21457.09c536.72-1068.4 1146.4-2663.17 1806.61-4142.78l449.97 466.44s-702.33 1378.6-994.82 2277.51c-292.49 898.92-1261.76 1398.83-1261.76 1398.83z",
    className: "fil3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6924.39 17267.98s-22.13 331.67-112.6 512.77c-90.48 181.1-332.73 304.3-345.92 264.69-13.2-39.61-147.98-632.4-147.98-632.4l128.17-543.44 303.03-393.56 175.3 791.94z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7173.7 14061.36s-161.45 398.17-66.76 731.83c94.69 333.65 44.59 533.82-24.2 365.64-68.8-168.18-97.11-470.17-116.53-113.03s128.12 830.41-6.34 802.95c-134.46-27.46-351.38-881.2-292.7-577.61 58.68 303.59 62.22 691.38-23.88 987.09-86.1 295.7-88.75 1002.04 107.19 1018.45 195.93 16.42 172.75 156.93 176.07-223.79 3.32-380.73-107.55-498.58 99.13-785.93 206.68-287.34 172.75-653.68 301.16-765.04 128.41-111.36 222.3-203.79 263.13-331.14 40.82-127.35-171.68-643.59-171.68-643.59l-244.59-465.83z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPajaro);
export default __webpack_public_path__ + "static/media/pajaro.b8f327de16e3d0a808651be8d7edb1e8.svg";
export { ForwardRef as ReactComponent };